import _ from 'lodash'
import { fetchDemandDetail } from '@/api/demand/demand'
import { cookDemand } from '../utils/cook-api-demand-info'
import { generateCreation } from '@/views/demand/utils/creation'
import { cookProducts } from '../create/utils'
import { cookCreationList } from '../create/utils'

// 结算相关数据
const settlement = {
  is_pay: '', // 是否付费
  currency: 1, // 币种
  exchange_rate: 6.6, // 汇率
  // revenue
  revenue_usd: '',
  revenue_cny: '',
  // cost
  cost_usd: '',
  cost_cny: '',
  is_prepaid: 1, // 预付
  prepaid_percent: '', // 预付比例
  crm_contract_no: '', // CRM合同编号
  invoice_id: '', // Related invoice
}

// channel setting 相关配置项
const channel_setting = {
  content_rating: '', // 适龄提示，只针对巨量引擎渠道生效
  ir_report_point: '', // 是否接入 ironsource 的埋点
  ir_creative_genre: '', // ironsrouce 的创意流派
}

// 创建/编辑/复制/详情/交付需求的页面的 mixin
export const curdDemandPageMixin = {
  data() {
    return {
      demand: {
        name: '', // 需求名称
        instruction: '', // 需求说明
        reference_url: '', // 创意参考资料 URL
        reference_name: '', // 创意参考资料名字
        category: '', // 需求归属分类
        expect_delivery_time: '', // 期望交付时间
        order_time: '', // 下单日期
        platform: 'ios', // 平台
        adv_name: '', // 广告主
        adv_id: '', // 广告主 ID
        key_account: '', // 用户类型

        channel_type: '', // 需求渠道
        type: '', // 需求类型，交互需求、非交互需求
        is_advertiser_review: '', // 广告主是否审核
        work_hours: '', // 非交互型需求排期工时
        estimated_time: '', // 预计完成时间
        deliver_time: '', // 实际完成时间
        products: [], // 产品信息
        creation_tasks: [], // 创新要求信息
        interactive_type: '', // 交互素材中的创意类型
        similar_demand_ids: [], // 提供设计&研发参考需求
        account_manager_id: '', // 客户经理id
        material_source: '', // 素材来源 1: 广告主 2: 内部 3：ss上传
        business_type: '', // 大媒体业务类型
        is_new_order: '', // 是否新单
        project_type: '', // 项目类型
        project_other: '', // 其他项目类型
        service_attribution: '', // 服务归属
        service_type: '', // 服务类型
        split_num: 1, // 需求拆分个数，默认是 1
        big_media_is_use_template: '', // 是否使用模板
        big_media_tpl_id: '', // 大媒体模板 id
        big_media_creative_type: '', // 大媒体创意类型
        big_media_creative_type_other: '', // 其他大媒体创意类型

        ...settlement,
        ...channel_setting,

        copy_id: '', // 如果是复制需求，记录源需求ID
        is_pt_custom: '', // 是否Playturbo定制，1是 2否
        is_make_dco: '', // 是否制作dco，1是 2否
        ia_material_type: '', // 交互素材素材类型
        case_auth_type: '', // 案例宣传授权（1 全部授权，2 不授权，3 部分授权
        case_remark: '', // 案例宣传备注
        nia_tag2_id: '', // 非交互素材二级标签（非交互素材）
        nia_tag3_id: '', // 非交互素材三级标签（非交互素材）
        meta_cl: '', // 垂类
        meta_pl: '', // 品类
        meta_tc: '', // 题材/风格
        biz_scenario: '', // 业务场景
        grade: '', // 分档
      },

      // 创意要求：会被 creation 表单组件双向绑定联动
      creationList: [generateCreation()],
      // 产品信息
      products: [],
      // 交付列表
      deliverList: [],

      // 策划案信息
      configureData: {},

      devTasks: [],

      // 增加Loading
      loading: true,
    }
  },

  methods: {
    async getDemandDetail(id) {
      this.loading = true
      try {
        const res = await fetchDemandDetail(id)
        const demand = _.get(res, 'data.data.info')
        const products = _.get(res, 'data.data.info.products')
        const creationTasks = _.get(res, 'data.data.info.creation_tasks')
        const deliverList = _.get(res, 'data.data.info.creations')

        this.devTasks = _.get(res, 'data.data.dev_tasks')
        this.configureData = _.get(res, 'data.data.design_config')
        if (this.configureData) {
          this.configureData.demand = demand
        }

        if (demand) {
          this.demand = {
            ...this.demand,
            ...cookDemand({ demand, creationTasks }),
          }
        }

        if (products) {
          // 延迟赋值，因为 platform 赋值之后，会重置 product 的值
          // 如果不做延迟，Vue 会将两次变动合并为一次，导致展示不正确
          this.$nextTick(() => {
            this.products = cookProducts(products, this.demand)
            // 编辑与复制需求时，在读取到 products 并赋值，product-info 组件监听 product.app_url 无法被触发，所以暴露一个事件出去
            this.$nextTick(() => {
              this.$root.$emit('demand:get-app-info')
            })
          })
        }

        if (creationTasks) {
          this.$nextTick(() => {
            this.creationList = cookCreationList(creationTasks, this.demand)
            this.$nextTick(() => {
              this.$root.$emit('demand:get-creation-size')
            })
          })
        }

        if (deliverList) {
          this.deliverList = deliverList.map((deliver) => {
            deliver.channel = deliver.channel_id
            delete deliver.channel_id
            return deliver
          })
        }
        this.loading = false
        return true
      } catch (err) {
        this.loading = false
        this.$message.error(err.message || '获取需求详情失败')
        return false
      }
    },
  },
}
